import React, { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { AiOutlineFolder } from "react-icons/ai";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import { useTheme } from '../../../ThemeContext';
import { getFileUrl } from '../../../api/api';

const FileRendererWithDialog = ({ file, open, onClose }) => {
  const { theme } = useTheme(); // Get theme from context
  const filePath = getFileUrl({ 
    projectId: file.projectId, 
    folderPath: file.folderPath, 
    fileName: file.orignalFileName,
    fileId: file._id 
  });
  const fileType = file.fileName.split(".").pop().toLowerCase();
  const fileName = file.fileName;

  const renderFile = () => {
    const documents = [{ uri: filePath, fileType: fileType, fileName: fileName }];
    // console.log(filePath)
    return (
      <div
        className={` ${
          theme === "dark" ? "bg-gray-100 text-gray-700" : "bg-white text-black"
        }`}
      >
        <DocViewer documents={documents} pluginRenderers={DocViewerRenderers} />
      </div>
    );
  };

  return (
    <div>
      <Transition appear show={open} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className={`fixed inset-0 ${
                theme === "dark" ? "bg-gray-900" : "bg-black"
              } bg-opacity-50 z-40`}
            />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto z-50">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className={`relative w-full max-w-4xl transform overflow-hidden rounded-lg p-6 shadow-2xl transition-all ${
                    theme === "dark" ? "bg-gray-800 text-white" : "bg-white text-gray-900"
                  }`}
                >
                  <button
                    type="button"
                    onClick={onClose}
                    className="absolute top-4 right-4 text-xl font-semibold text-gray-500 hover:text-gray-700 focus:outline-none"
                  >
                    &times;
                  </button>
                  
                  <Dialog.Title as="h3" className="text-xl font-semibold mb-4">
                    {file.fileName}
                  </Dialog.Title>

                  <div className="space-y-6">{renderFile()}</div>

                  <div className="flex justify-end mt-6">
                    <button
                      type="button"
                      onClick={onClose}
                      className="px-6 py-3 text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md shadow-lg"
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default FileRendererWithDialog;
